export const UPDATE_JOB_ROWS = 'UPDATE_JOB_ROWS';
export const UPDATE_AWARD_ROWS = 'UPDATE_AWARD_ROWS';
export const UPDATE_WORKER_ROWS = 'UPDATE_WORKER_ROWS';
export const WORK_STUDY_CONFIG = 'WORK_STUDY_CONFIG'